export default __webpack_public_path__ + "static/media/Raino Human.b6b6e3b3.jpeg";